	export function test(){
	console.log("Testing - confirmed.")
}
export function recordsetToDictionary(recordset, indexedField, aggregatableField){
			var dictionary = {}
			
			var counter = 0
			recordset.forEach(countryLoan => {
			counter = counter + 1
			JSON.stringify("countryLoan: |" + JSON.stringify(countryLoan) + "|")
			var currentValue = countryLoan[aggregatableField]
			var currentIndex = countryLoan[indexedField]
			var accummulatedVal = dictionary[currentIndex]

			if (!(accummulatedVal)){
				accummulatedVal = currentValue
			} else{
				accummulatedVal = accummulatedVal + currentValue
			}     		

			dictionary[currentIndex] = accummulatedVal
			})
			
			return dictionary		
}
export function aggDictionaryToPieFilling(aggDictionary){
			var pieFilling = []
			for(let entry in aggDictionary){
			var pieSlices = []
			pieSlices[0] = entry
			pieSlices[1] = aggDictionary[entry]
			pieFilling.push(pieSlices)
			}
			return pieFilling
}
export function parseColumnValues(recordset, targetedColumn){
	var parsedValues = []
	for(let index in recordset){
		var record = recordset[index]
		parsedValues.push(record[targetedColumn])
	}	
	return parsedValues
}
export function parseLineData(objList, xFieldName, yFieldName){
	var pointList = []
	objList.forEach(obj=> {
var pointCoords = []
		var xVal = obj[xFieldName]
var xValDate = new Date(xVal)
		xVal = xValDate.getTime()
		pointCoords.push(xVal)
		var yVal = obj[yFieldName]
		pointCoords.push(yVal)
		pointList.push(pointCoords)
	});
	return pointList
}
export function recordsetToPieFilling(recordset, indexedField, aggregatableField){
			var dictionary = recordsetToDictionary(recordset, indexedField, aggregatableField)
			var pieFilling = aggDictionaryToPieFilling(dictionary)
			return pieFilling		
}
